

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Highlight from 'vue-highlight-component';

@Component({
  components: {
    Highlight
  }
})
export default class PreviewModal extends Vue {
  @Prop({ type: Boolean, required: true }) readonly dialogVisible!: boolean;
  @Prop({ type: String, required: true }) readonly json!: string;
  private isDialogVisivble = false;

  @Watch('dialogVisible', { immediate: true })
  visibilityChanged (): void {
    this.isDialogVisivble = this.dialogVisible;
  }

  copy () {
    const newClip = this.json;
    navigator.permissions.query({ name: 'clipboard-write' as PermissionName }).then(result => {
      if (result.state === 'granted' || result.state === 'prompt') {
        navigator.clipboard.writeText(newClip).then(() => {
          this.$notify({
            title: 'Copied to clipboard ✌️',
            text: '',
            type: 'success'
          });
          this.$emit('close');
        });
      }
    });
  };
};
